export const styles = (theme) => ({
  volumeSlider: {
    width: "60px",
    marginLeft: 15,
    marginRight: 15,
    marginTop: -5,
  },
});
